const routes = [
  {
    path: 'carousel',
    name: 'carousel',
    component: () => import(/* webpackChunkName: "carousel" */ '@/modules/carousel/index.vue')
  },
];

export default routes;